<template>
  <span class="script-snippet" ref="snippet">
    <slot> </slot>
  </span>
</template>

<script setup lang="ts">
import { nextTick, onMounted, ref, watch } from "vue";

const snippet = ref<HTMLElement | null>(null);

const executeScript = () => {
  if (snippet.value) {
    try {
      const script = document.createElement("script");
      script.textContent = snippet.value.innerText;
      document.body.appendChild(script);
      document.body.removeChild(script);
    } catch (error) {
      console.error("Error executing script:", error);
    }
  }
};

watch(snippet, (newSnippet) => {
  if (newSnippet) {
    executeScript();
  }
});

onMounted(() => {
  nextTick(() => {
    executeScript();
  });
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.script-snippet {
  display: none;
}
</style>
